import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Dimmer } from "../components/spinner";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import axios from "axios";
import useTableScroll from "../components/useTableScroll.js";

const CatalogoClaseMultas = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const btnCancela = useRef();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const headCells = [
    { label: "ID", textAlign: "center" },
    { label: "DESCRIPCIÓN", textAlign: "center" },
    { label: "CÓDIGO", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idtipomulta.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.codigomulta.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const SeleccionarRegistros = (condi) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/multas/multasporclase?condi=${condi}`;
    console.log(endpoint);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          /*  var clase = []
                 for (let i = 0; i < response.data.length; i++) {
                     clase.push({
                         idclaseminas: response.data[i].idclaseminas,
                         descripcion: response.data[i].descripcion,
                         codigoclaseminas: response.data[i].codigoclaseminas,
                         alicuota: response.data[i].alicuota
                     })
                 } */
          setRecords(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setItemSelect("");
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const seleccionarClase = (index) => (event) => {
    var id = values.id;
    var codor = values.codor;
    var descrip = values.descrip;
    var valuni = values.valuni;
    var tipimp = values.tipimp;
    var factor = values.factor;
    blanquear();
    props.onHideAceptaCatClass(id, codor, descrip, valuni, tipimp, factor);
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);
    var id = recordsAfterPagingAndSorting()[index].idtipomulta;
    var codor = recordsAfterPagingAndSorting()[index].codigomulta;
    var descrip = recordsAfterPagingAndSorting()[index].descripcion;
    var valuni = recordsAfterPagingAndSorting()[index].valor;
    var tipimp = recordsAfterPagingAndSorting()[index].tipoimpuesto;
    var factor = recordsAfterPagingAndSorting()[index].factorcalculo;

    /*  var datos = [];
          datos.push */
    setValues({
      id,
      codor,
      descrip,
      valuni,
      tipimp,
      factor,
    });
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        SeleccionarRegistros(props.tipoimpuesto);
        /*if (props.tipoimpuesto === '1') {
                    SeleccionarRegistros('MINA')
                } else if (props.tipoimpuesto === 'produccion') {
                    SeleccionarRegistros('2')
                } else if (props.tipoimpuesto === '3') {
                    SeleccionarRegistros('1X500')
                } else if (props.tipoimpuesto === 'expendedores') {
                    SeleccionarRegistros('4')
                }*/
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Seleccionar Clase.</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} />
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-4  input-group-sm mb-3">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control rounded-pill"
              />
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={item.idclaseminas}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.idtipomulta}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.descripcion}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.codigomulta}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarClase()}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoClaseMultas;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoClaseMultas.js